<template>
  <div class="filter-panel">
    <div class="title">
      <div>
        <label>
          <span class="first">筛选条件设计</span>
          <el-tooltip v-if="selectPlate <= 1" content="点击单个筛选条件可进行属性设置" placement="top" class="tooltip">
            <span class="fa fa-question-circle"></span>
          </el-tooltip>
        </label>
        <div v-if="selectPlate > 1" class="graph-add-filters">
          <el-button icon="el-icon-plus" type="text" @click.stop="openSelectFilters">添加筛选条件</el-button>
          <div @click.stop v-if="showGraphFilters" class="graph-filter-column-list">
            <el-input v-model="keywords" clearable></el-input>
            <div v-if="copyAllColumns.length > 0" class="column-list-container">
              <div :class="['column-list-item', fetFilter(column) && 'select-column']" v-for="column in copyAllColumns" :key="column.id" @click="addColumn(column)" :title="getColumnName(column)">
                <span>{{ getColumnName(column) }}</span>
                <i class="el-icon-check"></i>
              </div>
            </div>
            <div v-else class="none-graph-columns">暂无数据</div>
          </div>
        </div>
        <div v-if="selectPlate <= 1" style="float: right">
         <report-button-component v-if="!(this.$route.query.dataSourceReport || this.reportService.report.dataSourceReport)" :type="'reportButton'"></report-button-component>
        </div>
      </div>
    </div>
    <div class="filter-wrapper filter" ref="filterWrapper">
      <div class="filter-box" :style="{'height':height+'px'}">
      <template v-for="item in array">
        <div class="filter-container" @dragover="allowDrop"  @drop.stop="drop($event,item.index)" :key="item.index">
         <draggable v-model="item.filters" @change="change($event,item.index)" @end="end(item.index)" class="layout-draggable" :options="{group:'draggable'}">
            <transition-group>
                <div class="component-wrapper" v-for="filter in item.filters"
                  :id="filter.id"
                  :key="filter.id"
                  @click.stop="openFilterAttr(filter)">
                  <label :title="filter.name.toString().length > 4 ? filter.name : ''">{{filter.name}}</label>
                  <filter-component class="filter-component"
                                    :filter="filter">
                  </filter-component>
                    <i class="el-icon-close" @click.stop="removeFilter(filter)"></i>
                </div>
            </transition-group>
         </draggable>
       </div>
      </template>
      </div>
      </div>

  </div>
</template>

<script>
import '@/plugins/gridster/gridster.css'
import FilterComponent from './filter-component'
import Filter from '@/store/report/filter'
import ReportButtonComponent from './report-button-component.vue'
import Draggable from 'vuedraggable'
import _ from 'lodash'
import Column from '../../../store/report/column'
export default {
  name: 'report-filter',
  inject: ['reportService'],
  props: ['selectPlate'],
  components: {
    FilterComponent,
    ReportButtonComponent,
    Draggable,
    Column
  },
  data () {
    return {
      style: false,
      page: {
        dragger: {
          mouseOffset: {}
        }
      },
      array: [
        {index: 1, filters: []},
        {index: 2, filters: []},
        {index: 3, filters: []},
        {index: 4, filters: []}
      ],
      keywords: '',
      showGraphFilters: false,
      allColumns: [],
      copyAllColumns: []
    }
  },
  methods: {
    allowDrop (event) {
      this.style = true
      event.preventDefault()
    },
    findPostion (evt) {
      let y = (evt.pageY - 150) + evt.currentTarget.parentElement.parentElement.scrollTop
      return {y}
    },
    drop (event, index) {
      this.style = false
      if (event.dataTransfer.getData('text').trim().length > 20) {
        let reportColumn = JSON.parse(event.dataTransfer.getData('text'))
        if (reportColumn && reportColumn.type === 'report') {
          let position = this.findPostion(event)
          position.row = Math.floor(position.y / 50)
          position.col = index
          let filter = Filter.create(reportColumn, position)
          let column = this.reportService.report.columns.find(m => m.id === filter.columnId)
          if (column) {
            filter.name = column.name
          }
          this.reportService.createOrUpdate(filter)
          // 当前索引后全部的row需要加1
          this.array[index - 1].filters.forEach((m, selfIndex) => {
            if (selfIndex > position.row) {
              m.position.row++
            }
          })
          this.array[index - 1].filters.splice(position.row, 0, filter)
          this.saveFilterRow(position.col)
        }
      }
      event.preventDefault()
    },
    end (col) {
      this.saveFilterRow(col)
    },
    change (evt, index) {
      if (evt.added) {
        evt.added.element.position.col = index
        this.reportService.createOrUpdate(evt.added.element)
        this.saveFilterRow(index)
      }
    },
    saveFilterRow (col) {
      this.array[col - 1].filters.forEach((m, index) => {
        m.position.row = index
      })
    },
    dragStop () {
      this.page.dragger.dragging = false
    },
    openFilterAttr (filter) {
      this.reportService.openPanel(filter.id, 'filter-panel')
    },
    removeFilter (filter) {
      this.reportService.delete(filter)
      let index = this.array[filter.position.col - 1].filters.findIndex(m => m.id === filter.id)
      if (index > -1) {
        this.array[filter.position.col - 1].filters.splice(index, 1)
      }
      this.saveFilterRow(filter.position.col)
      //  53期0121:筛选项列表删除对应设置值
      this.reportService.report.buttons.forEach(n => {
        if (n.type === 'filter-item-calculation' && n.filterItems[filter.id]) {
          delete n.filterItems[filter.id]
        }
      })
    },
    addColumn (column) {
      if (column) {
        let reportColumn = this.$_.cloneDeep(column)
        delete reportColumn.summary
        delete reportColumn.sort
        delete reportColumn.timeFormat
        delete reportColumn.basis
        reportColumn.type = 'report'
        let position = this.getGraphFilterPosition()
        let filter = Filter.create(reportColumn, position)
        let c = this.allColumns.find(m => m.id === filter.columnId)
        if (c) {
          filter.name = c.name
        }
        this.reportService.createOrUpdate(filter)
      }
    },
    openSelectFilters () {
      if (this.reportService.report.columns && this.reportService.report.columns.length) {
        this.allColumns = this.$_.merge([], this.reportService.report.columns)
        this.copyAllColumns = this.$_.merge([], this.reportService.report.columns)
      }
      this.$nextTick(() => {
        this.keywords = ''
        this.showGraphFilters = true
      })
    },
    getAllColumns () {
      let columns = []
      // 先拿主表的字段
      let tables = this.reportService.options.tables
      let mainTable = tables.find(t => t.id === this.reportService.report.mainTableId)
      if (mainTable && mainTable.columns && mainTable.columns.length > 0) {
        columns = [...mainTable.columns]
      }
      // 再拿从表的数据
      let joins = this.reportService.report.joins
      if (joins && joins.length > 0) {
        joins.forEach(j => {
          let table = this.reportService.findTables(j.referenceTableId)
          if (table.columns && table.columns.length > 0) {
            columns = [...columns, ...table.columns]
          }
        })
      }
      return columns
    },
    // 图形报表添加筛选条件是不可拖拽的，只能按顺序添加
    // row：列
    // col：行
    getGraphFilterPosition () {
      let position = {row: 1, col: 1}
      for (let i = 0; i < this.array.length; i++) {
        if (i < 3) {
          if (this.array[i].filters.length === 0) {
            position = {row: i, col: 1}
            break
          } else {
            if (this.array[i].filters.length > this.array[i + 1].filters.length) {
              position = {row: this.array[i + 1].filters.length + 1, col: i + 2}
              break
            }
          }
        } else if (i === 4) {
          position = {row: 4, col: this.array[i].filters.length + 1}
          break
        }
      }
      return position
    },
    dragableEvent (e) {
      e.preventDefault()
      e.stopPropagation()
      e.dataTransfer.dropEffect = 'copy'
      e.dataTransfer.effectAllowed = 'copy'
    }
  },
  watch: {
    getOrdinaryFilter: {
      handler (value) {
        if (this.array.length && value) {
          this.array.forEach((m, n) => {
            m.filters = _.sortBy(value.filter(m => parseInt(m.position.col) === n + 1), ['position.row'])
          })
        }
      },
      immediate: true
    },
    keywords (val) {
      let allColumns = this.$_.merge([], this.allColumns)
      if (val) {
        this.copyAllColumns = allColumns.filter(item => item.name.includes(val) || (item.pinyinName && item.pinyinName.includes(val)) || (item.pinyinFirstChar && item.pinyinFirstChar.includes(val)))
      } else {
        this.copyAllColumns = allColumns
      }
    }
  },
  computed: {
    height () {
      return (Math.max(this.array[0].filters.length, this.array[1].filters.length, this.array[2].filters.length, this.array[3].filters.length) + 1) * 58
    },
    getOrdinaryFilter () {
      if (this.reportService.report.mainTableId) {
        return this.reportService.report.filters.filter(m => {
          return m.filterType !== 'senior'
        })
      }
    },
    fetFilter (column) {
      return column => {
        let result
        this.array.forEach(item => {
          if (!result) {
            if (item.filters && item.filters.length > 0) {
              result = item.filters.find(f => f.columnId === column.id)
            }
          }
        })
        return result
      }
    },
    getColumnName (column) {
      return column => column.tableName ? `${column.tableName}-${column.name}` : column.name
    }
  },
  mounted () {
    document.getElementById('app').addEventListener('click', () => {
      if (this.showGraphFilters) {
        this.showGraphFilters = false
      }
    })
    // 筛选项允许拖动事件
    this.$refs.filterWrapper.addEventListener('drop', this.dragableEvent)
    this.$refs.filterWrapper.addEventListener('dragover', this.dragableEvent)
  },
  beforeDestroy () {
    // 销毁拖动事件
    this.$refs.filterWrapper.removeEventListener('drop', this.dragableEvent)
    this.$refs.filterWrapper.removeEventListener('dragover', this.dragableEvent)
  }
}
</script>

<style lang="scss">
.filter-panel {
  .filter-wrapper.filter {
    margin-top: 3px;
    margin-left: 15px;
    margin-right: 16px;
    height: 100%;
    height: 124px;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    .filter-box {
      min-height: 100%;
      background: #f2f7fb;
      display: flex;
      width: 100%;
      background-size: 25% 57px;
      background-image:linear-gradient(90deg,#fff,#fff 6px,transparent 0,transparent),linear-gradient(180deg,#fff,#fff 12px,transparent 0px,transparent 90px);
    }
    .filter-container {
      flex: 1;
      width: 25%;
      margin: 0 0 0 5px;

      .layout-draggable {
        padding-top: 12px;

        >span {
          height: 100%;
          display: block;
          padding-bottom: 50px;

          .component-wrapper {
            background-color: #DEF0FF;
            line-height: 45px;
            height: 45px;
            position: relative;
            margin-bottom: 12px;

            label {
              color: #333;
              font-size: 12px;
              width: 80px;
              display: inline-block;
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              vertical-align: middle;
              padding-left: 12px;
            }

            .filter-component {
              width: calc(100% - 95px);
              padding-left: 5px;
              display: inline-block;
            }

            .el-icon-close {
              position: absolute;
              top: 2px;
              padding-top: 1px;
              padding-right: 2px;
              display: none;
              color: #333;
              cursor: pointer;
            }

            .el-icon-close {
              right: 0;

              &:hover {
                color: #c00000;
              }
            }

            &:hover {
              .el-icon-close {
                display: block;
              }
            }
          }

          .sortable-ghost {
            background: #ECF6FF;
          }
        }
      }
    }

  }
  .title {
    padding-bottom: 10px;

    .tooltip {
      font-size: 16px;
      cursor: pointer;
      margin-left: 10px;
    }

    >div {
      padding: 16px 15px 0 28px;
      position: relative;

      &::before {
        content: "";
        width: 2px;
        height: 14px;
        background: #54abf1;
        position: absolute;
        left: 20px;
        top: 19px;
      }

      .second {
        font-size: 12px;
        margin-left: 10px;
        color: #aaabab;
      }
    }
  }
  .senior-filter {
    float: right;
    color: #409EFF;
    cursor: pointer;
  }
  .graph-add-filters {
    margin-left: 17px;
    position: relative;
    display: inline-block;
    .el-button {
      width: 16px;
      padding: 0;
    }
    .graph-filter-column-list {
      position: absolute;
      left: 0;
      top: 20px;
      width: 246px;
      height: 256px;
      background: #fff;
      border: 1px solid rgba(238,241,243,1);
      box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.09);
      border-radius: 4px;
      padding: 12px 16px;
      z-index: 999;
      .column-list-container {
        height: calc(100% - 25px);
        padding-top: 6px;
        overflow: auto;
        padding-left: 2px;
        .column-list-item {
          height: 28px;
          line-height: 28px;
          cursor: pointer;
          position: relative;
          .el-icon-check {
            position: absolute;
            right: 0;
            top: 6px;
            display: none;
          }
          &:hover {
            background-color: #ecf5ff;
          }
        }
        .select-column {
          color: #54ABF1;
          .el-icon-check {
            display: inline-block;
          }
        }
      }
      .none-graph-columns {
        height: calc(100% - 25px);
        padding-top: 6px;
        overflow: auto;
        padding-left: 2px;
        padding-top: 70px;
        text-align: center;
        color: #999;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/design/report-filter.vue